export default __webpack_public_path__ + "static/media/back-icon.93767c96.svg";